import * as React from 'react'
import TableTextRow from '@/modules/drivers/shared/tableItems/TableTextRow'
import { Violation } from '@/app/types/creator'
import { ViolationModel } from '@/app/models/violationModel'
import { faChevronDownSolid, FaIcon } from '@/lib/fa'
import { useDate } from '@/modules/drivers/stores/dateStore'
import ViolationDetailsTable from './ViolationDetailsTable'
import useViolationService from '@/modules/drivers/services/ViolationService'

export const ViolationRowItem = ({
  violation,
  companyId,
}: {
  violation: Violation | any
  companyId: string
}) => {
  const { formatApiDate, range } = useDate()

  const { getViolations: getViolationsService } = useViolationService()

  const [isHovered, setIsHovered] = React.useState(false)
  const [isExpanded, setIsExpanded] = React.useState(false)
  const [subTableData, setSubTableData] = React.useState<ViolationModel[]>([])
  const [isLoadingDetails, setIsLoadingDetails] = React.useState(false)


  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)

  const fetchDetails = async () => {
    if (isExpanded) {
      setIsExpanded(false)
      return
    }

    if (subTableData.length === 0) {
      setIsLoadingDetails(true)
      try {
        const data = await getViolations({ driverId: violation?.driverId })
        setSubTableData(data || [])
        setIsExpanded(true)
      } catch (err) {
        console.error('Error fetching violation details:', err)
      } finally {
        setIsLoadingDetails(false)
      }
    } else {
      setIsExpanded(true)
    }
  }
  const getViolations = React.useCallback(
    async ({ driverId }: { driverId: number }): Promise<ViolationModel[]> => {
      const startDate = new Date(
        range.startDate.year!,
        range.startDate.month! - 1,
        range.startDate.day!,
      )
      const endDate = new Date(
        range.endDate.year!,
        range.endDate.month! - 1,
        range.endDate.day!,
      )
      const startTime = formatApiDate(startDate)
      const endTime = formatApiDate(endDate)
      return getViolationsService({
        companyId,
        driverId,
        startTime,
        endTime,
      })
    },
    [companyId, getViolationsService, range, formatApiDate],
  )
  return (
    <>
      <tr
        className={`notches-border--right tw-relative tw-w-fit tw-cursor-pointer tw-border-b hover:tw-bg-primary/10 tw-bg-white `}
        onClick={fetchDetails}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
       
        <TableTextRow size="medium" textSize="sm">
          {violation?.fullName}
        </TableTextRow>
        <TableTextRow size="medium" textSize="sm">
          {violation?.amount_NN ?? '-'}
        </TableTextRow>
        <TableTextRow size="medium" textSize="sm">
          {violation?.amount_BPN ?? '-'}
        </TableTextRow>
        <TableTextRow size="medium" textSize="sm">
          {violation?.amount_PN ?? '-'}
        </TableTextRow>
        <TableTextRow size="medium" textSize="sm">
          {violation?.amount_ZN ?? '-'}
        </TableTextRow>
        <TableTextRow size="medium" textSize="sm">
          <div className="tw-flex tw-w-full tw-items-center tw-justify-between">
            <p>
              {(
                (violation?.driverCharge ?? 0) + (violation?.companyCharge ?? 0)
              ).toFixed(2)}
            </p>
            <div
              className={`tw-rounded-lg tw-bg-secondary tw-p-1 ${isExpanded ? 'tw-rotate-180' : ''} tw-transition-transform`}
            >
              <FaIcon className="tw-h-4 tw-w-4" icon={faChevronDownSolid} />
            </div>
          </div>
        </TableTextRow>
      </tr>
      {isExpanded && (
        <tr className="tw-border-b tw-border-base-300">
          <td colSpan={7} className="tw-bg-[#F2F2F240] tw-py-0">
            <ViolationDetailsTable
              violations={subTableData}
              isLoadingDetails={isLoadingDetails}
            />
          </td>
        </tr>
      )}
    </>
  )
}
